module.exports = __webpack_public_path__ + "assets/img/title-640d81c1.png";